import { useContext, useEffect, useState } from "react";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { AppContext } from "../App";
import { DateSelection } from "../components/DateSelection";

export const SelectDateTime = (props) => {
	const { FLOW } = useContext(AppContext);
	const nextPage = FLOW === "mapfre" ? "loader" : "bookingEnd";
	const previousPage = "damageGlass";

	return (
		<>
			<Header />
			<Content />
			<Footer nextPage={nextPage} previousPage={previousPage} />
		</>
	);
};

const Content = () => {
	const { data, setData, isTransitioning } = useContext(AppContext);
	const [hours, setHours] = useState([]);
	const [loading, setLoading] = useState(false);

	const handleTimeSelection = (time) => () => {
		setData({ ...data, time });
	};

	useEffect(() => {
		if (!data.centerCode || !data.date) return;

		setLoading(true);

		let API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

		let controller = new AbortController();
		let options = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
			signal: controller.signal,
		};

		fetch(
			`${API_URL}/availability/${data.centerCode}/${data.date}?locator=${data.locator}`,
			options
		)
			.then((res) => res.json())
			.then((newData) => {
				if (newData.result === "ok") {
					setHours(newData.hours);
				}
			})
			.catch((err) => {
				console.error(err);
			})
			.finally(() => {
				setLoading(false);
				controller.abort();
			});
	}, [data.centerCode, data.date, data.locator]);

	return (
		<div
			className={
				"content content_calendar kensei_03" +
				(isTransitioning ? " fade-in" : "")
			}
		>
			<div className="content_calendar_date">
				<div className="content_title">
					<h3 className="content_calendar_header">
						Elige cuándo te gustaría venir
					</h3>
				</div>

				<DateSelection />
			</div>

			{data.date && (
				<div className="content_calendar_time">
					<div className="content_title">
						<h3 className="content_calendar_header">
							Elige una hora
						</h3>
					</div>
					{loading ? (
						<div className="loader">
							<div className="spinner"></div>
						</div>
					) : hours.length > 0 &&
					  hours[0]?.length > 0 &&
					  hours[1]?.length > 0 ? (
						<div className="content_time">
							{hours[0]?.length > 0 && (
								<div className="content_time_morning">
									<p className="content_time_header">
										Por la mañana
									</p>
									<div className="content_time_slots">
										{hours[0].map((hour, index) => (
											<span
												className={
													"kensei_03" +
													(data.time === hour
														? " selected"
														: "")
												}
												key={index}
												onPointerDown={handleTimeSelection(
													hour
												)}
											>
												{hour}
											</span>
										))}
									</div>
								</div>
							)}

							{hours[1]?.length > 0 && (
								<div className="content_time_afternoon">
									<p className="content_time_header">
										Por la tarde
									</p>
									<div className="content_time_slots">
										{hours[1].map((hour, index) => (
											<span
												className={
													data.time === hour
														? " selected"
														: ""
												}
												key={index}
												onPointerDown={handleTimeSelection(
													hour
												)}
											>
												{hour}
											</span>
										))}
									</div>
								</div>
							)}
						</div>
					) : (
						<p className="no-availability">
							No hay horarios disponibles.
						</p>
					)}
				</div>
			)}
		</div>
	);
};
